<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap justify-space-between>
        <v-toolbar flat dense light color="rgba(0,0,0,0)">
          <v-toolbar-title>Jobs</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-flex >
          <jobs-table />
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'
import jobsTable from './_table'

export default {
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: 'status'
      },
      jobs: [],
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Remodeler',
          value: 'remodeler_name'
        },
        {
          text: 'Status',
          value: 'approval_status'
        },
        {
          text: 'Actions'
        }
      ]
    }
  },
  components: {
    Layout,
    jobsTable
  },
  methods: {
    getColor (status) {
      if (status === 'APPROVED') return 'green'
      else if (status === 'Pending') return 'orange'
      else return 'red'
    }
  },
  mounted () {
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Jobs/index.vue